module.exports = __webpack_public_path__ + "static/media/AeroGCSInactive.7c5fe594.png";